import { FormRadioListComponent } from './components/form-radio-list/form-radio-list.component';
import { FormInputV2Component } from './components/form-input-v2/form-input-v2.component';
import { FormConnectedAddressComponent } from './components/form-connected-address/form-connected-address.component';
import { FormSelectSearchComponent } from './components/form-select-search/form-select-search.component';

// extends dynamic form fields
export const formControls = {
  'radio-list': FormRadioListComponent,
  'NIEUW': FormInputV2Component,
  'connected-address': FormConnectedAddressComponent,
  'select-search': FormSelectSearchComponent,
};
